<template>
<div>
    <NuxtLayout :name='layout'>
        <template #body_page>
            <div class='notfound-page flex justify-center' :style="[$device.isDesktop ? 'min-height: calc(100vh - 131px)' : 'min-height: calc(100vh - 101px)']" >
                <div>
                    <div class='pa-60 mb-pa-30 bg-white  tc maxw-360 mb-w-300 br-16 sd-1 mt-120 mb-120'>
                        <h2 class='mb-30 fs-36 mb-fs-28 fw-900'>Are you lost?</h2>
                        <p class='mb-30 fs-18 lh-22'>You’ve travelled too far!</p>
                        <p class='mb-30  fs-18 lh-22'>We are sorry, but the page you are looking for can’t be found.</p>
                        <p style='display: none'>{{ error?.statusCode }}</p>
                        <div>
                            <button class='button button-primary' @click="backToHome">Back to Homepage</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </NuxtLayout>
</div>
</template>

<script setup>
import {useRouter } from "vue-router";

const router = useRouter()
const layout = "no-footer-layout"
const error = useError()

// const windowWidth = computed(() => store.state.generalStore.generalData.windowWidth)

const backToHome = () => {
  router.push({ path: '/' })
}

</script>
<style scoped lang="scss">
.notfound-page {
  background-image: url('#{$assets-cdn}/images/notfound/bg-notfound.jpg');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  width: 100%;
  @include phone {
    background-image: url('#{$assets-cdn}/images/notfound/mb-bg-notfound.jpg');
  }
}
</style>

